"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentDevice = void 0;
var useCurrentDevice_1 = require("./useCurrentDevice");
Object.defineProperty(exports, "useCurrentDevice", { enumerable: true, get: function () { return useCurrentDevice_1.useCurrentDevice; } });
//# sourceMappingURL=index.js.map